<template>
  <div v-if="cruise != null">
    <div class="dashboard-main-content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-12">
            <form id="cruiseDetailBigForm">
              <div class="form-box">
                <div class="form-content pb-2">
                  <div class="row justify-content-between">
                    <div class="col-lg-6">
                      <div class="card-item p-3">
                        <div class="contact-form-action">
                          <h3 class="title mb-3">Cruise</h3>
                          <base-edit-input
                              v-model="cruise.name"
                              :rules="'required'"
                              :type="'text'"
                              :label="'Adı'">
                          </base-edit-input>
                          <base-text-area-input
                              v-model="cruise.description"
                              :rules="'required'"
                              :label="'Açıklama'">
                          </base-text-area-input>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="card-item p-3">
                        <div class="contact-form-action">
                          <h3 class="title mb-3">İstatistik</h3>
                          <div class="row">
                            <div class="col-md-6">
                              <base-edit-input
                                  v-model="cruise.statistics.ageOfShip"
                                  :rules="'required|min_value:1'"
                                  :type="'number'"
                                  :label="'Yaş'">
                              </base-edit-input>
                            </div>
                            <div class="col-md-6">
                              <base-edit-input
                                  v-model="cruise.statistics.tonnage"
                                  :rules="'required|min_value:1'"
                                  :type="'number'"
                                  :label="'Tonaj'">
                              </base-edit-input>
                            </div>
                            <div class="col-md-6">
                              <base-edit-input
                                  v-model="cruise.statistics.length"
                                  :rules="'required|min_value:1'"
                                  :type="'number'"
                                  :label="'Uzunluk'">
                              </base-edit-input>
                            </div>
                            <div class="col-md-6">
                              <base-edit-input
                                  v-model="cruise.statistics.beam"
                                  :rules="'required|min_value:1'"
                                  :type="'number'"
                                  :label="'Genişlik'">
                              </base-edit-input>
                            </div>
                            <div class="col-md-6">
                              <base-edit-input
                                  v-model="cruise.statistics.speed"
                                  :rules="'required|min_value:1'"
                                  :type="'number'"
                                  :label="'Hız'">
                              </base-edit-input>
                            </div>
                            <div class="col-md-6">
                              <base-edit-input
                                  v-model="cruise.statistics.guestCapacity"
                                  :rules="'required|min_value:1'"
                                  :type="'number'"
                                  :label="'Yolcu Kapasitesi'">
                              </base-edit-input>
                            </div>
                            <div class="col-md-6">
                              <base-edit-input
                                  v-model="cruise.statistics.totalStaff"
                                  :rules="'required|min_value:1'"
                                  :type="'number'"
                                  :label="'Toplam Mürettebat'">
                              </base-edit-input>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="btn-box">
                    <button v-if="cruise.id == null" :class="{'disabled' : !formValid}" @click="create" class="theme-btn" type="button">Kaydet</button>
                    <button v-if="cruise.id != null" :class="{'disabled' : !formValid}" @click="update" class="theme-btn" type="button">Güncelle</button>
                  </div>
                  <div class="section-block mb-4"></div>
                  <div class="row" v-if="cruise.id != null">
                    <div class="col-lg-12">
                      <deck-list></deck-list>
                    </div>
                  </div>
                  <div class="section-block mb-4"></div>
                  <div class="row" v-if="cruise.id != null">
                    <div class="col-lg-12">
                      <room-list></room-list>
                    </div>
                  </div>
                  <div class="section-block mb-4"></div>
                  <div class="row" v-if="cruise.id != null">
                    <div class="col-lg-12">
                      <cruise-room-list></cruise-room-list>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div>
      <deck-detail></deck-detail>
      <cruise-room-detail></cruise-room-detail>
      <room-detail></room-detail>
    </div>
  </div>
</template>

<script>
import UploadImage from "../common/UploadImage";
import DeckList from "./deck/DeckList";
import CruiseRoomList from "./cruiseroom/CruiseRoomList";
import RoomList from "./room/RoomList";
import DeckDetail from "./deck/DeckDetail";
import CruiseRoomDetail from "./cruiseroom/CruiseRoomDetail";
import RoomDetail from "./room/RoomDetail";
import BaseEditInput from "../base/BaseEditInput";
import BaseTextAreaInput from "../base/BaseTextAreaInput";
import validationFormUtils from "../../util/validationFormUtils";

export default {
  name: "CruiseDetail",
  components: {
    BaseTextAreaInput,
    BaseEditInput,
    RoomDetail, CruiseRoomDetail, DeckDetail, RoomList, CruiseRoomList, DeckList, UploadImage},
  data:function (){
    return{
      formValid:false
    }
  },
  computed:{
    cruise:{
      get(){
        return this.$store.getters.getCruise;
      },
      set(value){
        this.$store.commit("setCruise",value)
      }
    },
    room:{
      get(){
        return this.$store.getters.getRoom;
      }
    },
    deck:{
      get(){
        return this.$store.getters.getDeck;
      }
    },
    cruiseRoom:{
      get(){
        return this.$store.getters.getCruiseRoom;
      }
    },
  },
  methods:{
    create(){
      if(this.formValid) {
        this.$store.dispatch("createCruise", this.$store.getters.getCruise).then((response)=>{
          this.$router.push("/cruises");
        });
      }
    },
    update(){
      if(this.formValid) {
        this.$store.dispatch("updateCruise", this.$store.getters.getCruise).then((response)=>{
          this.$router.push("/cruises")
        })
      }
    }
  },
  watch:{
    cruise:{
      deep:true,
      handler:function (){
        validationFormUtils.checkFormFields(this);
      }
    }
  }
}
</script>

<style scoped>

</style>